import React from "react";
import PropTypes from "prop-types";
import OneCol, { Row } from "layouts/OneCol";
import Header from "components/views/Header";
import T from "i18n";
import PageHeading from "components/views/atoms/PageHeading";
import ProgressHeading from "components/views/ProgressHeading";
import EndOfPageNotes from "components/views/EndOfPageNotes";
import OutlinedMoreHelp from "components/views/OutlinedMoreHelp";
import OutlinedLinksGrid from "components/views/OutlinedLinksGrid";
import GasTypeList from "components/containers/GasTypeList";
import Footer from "components/views/atoms/Footer";

const GasType = ({ className, breadcrumbs }) => {
  const classes = ["GasType"];
  if (className) classes.push(className);
  const bc = breadcrumbs.map((b) => b());

  return (
    <OneCol className={classes.join(" ")}>
      <Header heading="Commercial" />
      <PageHeading>
        <T path="common.productSelector" />
      </PageHeading>

      <Row fullWidth>
        <ProgressHeading
          perc={80}
          heading={T({ path: "gasTypePage.progressHeading" })}
          breadcrumbSteps={bc}
        />
      </Row>

      <Row>
        <GasTypeList />
      </Row>

      <Row>
        <OutlinedLinksGrid>
          <OutlinedMoreHelp LinkLabel={T({ path: "button.moreHelpUrl" })} />
        </OutlinedLinksGrid>
      </Row>

      <Row>
        <EndOfPageNotes />
      </Row>

      <Footer />
    </OneCol>
  );
};

GasType.displayName = "GasType";

GasType.propTypes = {
  className: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(PropTypes.func),
};

GasType.defaultProps = {
  className: null,
  breadcrumbs: [],
};

export default GasType;
